import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { system } from 'styled-system';
import { Box, BoxProps } from '../next-components/box';
type Props = BoxProps & JSX.IntrinsicElements['ul'] & Pick<BoxProps['style'], 'listStyle' | 'listStyleType' | 'listStylePosition' | 'listStyleImage'>;
const listStyle = system({
  listStyle: {
    property: 'listStyle'
  },
  listStyleType: {
    property: 'listStyleType'
  },
  listStylePosition: {
    property: 'listStylePosition'
  },
  listStyleImage: {
    property: 'listStyleImage'
  }
});
export const UL = styled(Box).attrs<Props>(() => ({
  as: 'ul'
}))(listStyle) as unknown as FunctionComponent<React.PropsWithChildren<Props>>;
export type ULProps = Props;